export default __webpack_public_path__ + "static/media/Bindings of the Whispering Blade.980df5e9.jpg";